"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useContainerHeight = (selector, width) => {
  const [containerHeight, setContainerHeight] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (typeof document !== "undefined") {
      const elem = document.querySelector(`.${selector}`);
      let height;
      if (elem) {
        height = elem.clientHeight;
      }
      setContainerHeight(height);
    }
  }, [width]);
  return {
    containerHeight
  };
};
var _default = useContainerHeight;
exports.default = _default;